import { PINNACLE_TRANSFORM_CONFIG } from "@/configuration/groups/pinnacle/lab-abbreviations";
import { getGroupConfigSubdomain } from "@/configuration/paths";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import type { Group } from "@/src/models/group";

export type LabAbbreviation = {
  readonly aliases: readonly string[];
  readonly canonical: string;
};

export interface FieldTransformConfig {
  signatureRequired?: {
    trueValue: string;
    falseValue: string;
  };
  vaccineType?: {
    emptyValue: string;
    suffix: string;
  };
  isSigned?: {
    trueValue: string;
    falseValue: string;
  };
  significantFindings?: {
    trueValue: string;
    falseValue: string;
  };
  abnormal?: {
    trueValue: string;
    falseValue: string;
  };
  followUpRequired?: {
    trueValue: string;
    falseValue: string;
  };
  orderNumber?: {
    emptyValue: string;
  };
  specialty?: {
    emptyValue: string;
  };
  listOfNameOfLabs?: {
    maxLength: number;
    maxRange: number;
    abbreviations?: readonly LabAbbreviation[];
    priorityAbbreviations?: readonly string[];
  };
  labTypesAndResults?: {
    maxRange: number;
  };
}

export const DEFAULT_CONFIG: FieldTransformConfig = {
  signatureRequired: {
    trueValue: "Sig Reqd",
    falseValue: "",
  },
  vaccineType: {
    emptyValue: "Iz",
    suffix: " Notice",
  },
  isSigned: {
    trueValue: "FINAL",
    falseValue: "",
  },
  significantFindings: {
    trueValue: "sig findings",
    falseValue: "",
  },
  abnormal: {
    trueValue: "Abnormal ",
    falseValue: "",
  },
  followUpRequired: {
    trueValue: "true",
    falseValue: "false",
  },
  orderNumber: {
    emptyValue: "",
  },
  specialty: {
    emptyValue: "",
  },
  listOfNameOfLabs: {
    maxLength: 45,
    maxRange: 2,
  },
  labTypesAndResults: {
    maxRange: 2,
  },
};

export function getTransformConfig(group: Pick<Group, "subdomain">): FieldTransformConfig {
  switch (getGroupConfigSubdomain(group)) {
    case ConfigSubdomain.PINNACLE:
      return PINNACLE_TRANSFORM_CONFIG;
    default:
      return DEFAULT_CONFIG;
  }
}
